"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostBatchApproveInvoicesRequestAllToJSON = exports.PostBatchApproveInvoicesRequestAllFromJSONTyped = exports.PostBatchApproveInvoicesRequestAllFromJSON = exports.instanceOfPostBatchApproveInvoicesRequestAll = exports.PostBatchApproveInvoicesRequestAllInvoiceMethodEnum = exports.PostBatchApproveInvoicesRequestAllInvoiceStatusEnum = void 0;
const runtime_1 = require("../runtime");
const PostBatchApproveInvoicesRequestAllCycle_1 = require("./PostBatchApproveInvoicesRequestAllCycle");
/**
* @export
* @enum {string}
*/
var PostBatchApproveInvoicesRequestAllInvoiceStatusEnum;
(function (PostBatchApproveInvoicesRequestAllInvoiceStatusEnum) {
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Shared"] = "shared";
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Failed"] = "failed";
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Paid"] = "paid";
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Scheduled"] = "scheduled";
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Draft"] = "draft";
    PostBatchApproveInvoicesRequestAllInvoiceStatusEnum["Open"] = "open";
})(PostBatchApproveInvoicesRequestAllInvoiceStatusEnum || (exports.PostBatchApproveInvoicesRequestAllInvoiceStatusEnum = PostBatchApproveInvoicesRequestAllInvoiceStatusEnum = {}));
/**
* @export
* @enum {string}
*/
var PostBatchApproveInvoicesRequestAllInvoiceMethodEnum;
(function (PostBatchApproveInvoicesRequestAllInvoiceMethodEnum) {
    PostBatchApproveInvoicesRequestAllInvoiceMethodEnum["Auto"] = "auto";
    PostBatchApproveInvoicesRequestAllInvoiceMethodEnum["Manual"] = "manual";
})(PostBatchApproveInvoicesRequestAllInvoiceMethodEnum || (exports.PostBatchApproveInvoicesRequestAllInvoiceMethodEnum = PostBatchApproveInvoicesRequestAllInvoiceMethodEnum = {}));
/**
 * Check if a given object implements the PostBatchApproveInvoicesRequestAll interface.
 */
function instanceOfPostBatchApproveInvoicesRequestAll(value) {
    let isInstance = true;
    isInstance = isInstance && "cycle" in value;
    return isInstance;
}
exports.instanceOfPostBatchApproveInvoicesRequestAll = instanceOfPostBatchApproveInvoicesRequestAll;
function PostBatchApproveInvoicesRequestAllFromJSON(json) {
    return PostBatchApproveInvoicesRequestAllFromJSONTyped(json, false);
}
exports.PostBatchApproveInvoicesRequestAllFromJSON = PostBatchApproveInvoicesRequestAllFromJSON;
function PostBatchApproveInvoicesRequestAllFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cycle': (0, PostBatchApproveInvoicesRequestAllCycle_1.PostBatchApproveInvoicesRequestAllCycleFromJSON)(json['cycle']),
        'needsAttention': !(0, runtime_1.exists)(json, 'needsAttention') ? undefined : json['needsAttention'],
        'invoiceStatus': !(0, runtime_1.exists)(json, 'invoiceStatus') ? undefined : json['invoiceStatus'],
        'clientLabelId': !(0, runtime_1.exists)(json, 'clientLabelId') ? undefined : json['clientLabelId'],
        'invoiceMethod': !(0, runtime_1.exists)(json, 'invoiceMethod') ? undefined : json['invoiceMethod'],
        'idsToIgnore': !(0, runtime_1.exists)(json, 'idsToIgnore') ? undefined : json['idsToIgnore'],
    };
}
exports.PostBatchApproveInvoicesRequestAllFromJSONTyped = PostBatchApproveInvoicesRequestAllFromJSONTyped;
function PostBatchApproveInvoicesRequestAllToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cycle': (0, PostBatchApproveInvoicesRequestAllCycle_1.PostBatchApproveInvoicesRequestAllCycleToJSON)(value.cycle),
        'needsAttention': value.needsAttention,
        'invoiceStatus': value.invoiceStatus,
        'clientLabelId': value.clientLabelId,
        'invoiceMethod': value.invoiceMethod,
        'idsToIgnore': value.idsToIgnore,
    };
}
exports.PostBatchApproveInvoicesRequestAllToJSON = PostBatchApproveInvoicesRequestAllToJSON;
//# sourceMappingURL=PostBatchApproveInvoicesRequestAll.js.map